import { createRequest } from '@shared/services';

export enum PRODUCT_GROUP_SOURCE_TYPE {
    SELECTED = 'selected',
    RECOMMEND = 'recommend',
    KEYWORD = 'keyword',
    CATEGORY = 'category',
}

export enum PRODUCT_GROUP_SORTING_TYPE {
    UPDATE_DATETIME = 'update_datetime',
    POPULARITY = 'popularity',
}

export interface GetProductCardArgTypes {
    type?: PRODUCT_GROUP_SOURCE_TYPE;
    query?: string | null;
    order_by?: PRODUCT_GROUP_SORTING_TYPE;
    per_page?: number;
    asc?: boolean;
}

export async function getProductCard(args: GetProductCardArgTypes) {
    const { type, query, order_by, per_page, asc = true } = args;

    const request = createRequest<GetProductCardResponse>({
        url: '/product/card',
        method: 'GET',
        withAuthorization: true,
        params: {
            type,
            query,
            order_by,
            per_page,
            asc,
        },
    });

    return request.execute();
}
